/** Messenger home card (30 Oct 2026). `web_chat_widgets.messenger` holds the
 *  Facebook Page the "Chat on Messenger" card opens: its username
 *  ("litehouselighting") or numeric id, and an optional `ref` that m.me hands
 *  to the Page's webhook with the first message. NULL column = no card. */
export type MessengerConfig = { page: string; ref?: string };

/** Accepts a username, a numeric Page id, or a pasted facebook.com / m.me
 *  link, and returns the bare Page handle, or "" when nothing usable is left. */
export function messengerPageHandle(page: string | null | undefined): string {
  let p = (page || "").trim();
  p = p.replace(/^https?:\/\//i, "").replace(/^(www\.|web\.|m\.)?(facebook\.com|fb\.com|m\.me|messenger\.com\/t)\/?/i, "");
  p = p.replace(/^profile\.php\?id=/i, "").replace(/^@/, "");
  p = p.split(/[/?#]/)[0];
  return /^[A-Za-z0-9.]{3,100}$/.test(p) ? p : "";
}

/** https://m.me/<page>[?ref=…], or null when the Page handle is unusable. */
export function messengerLink(cfg: MessengerConfig | null | undefined): string | null {
  const handle = messengerPageHandle(cfg?.page);
  if (!handle) return null;
  const ref = (cfg?.ref || "").trim();
  return `https://m.me/${handle}${ref ? `?ref=${encodeURIComponent(ref)}` : ""}`;
}
